import { initialTableShow } from 'utils/settings';

export const mainTableConf = [
  {
    isSortable: false,
    field: 'priority',
    title: 'Priority',
    show: true,
    width: 102,
    valuesExport: ['priority']
  },
  {
    isSortable: true,
    field: 'status',
    title: 'Status',
    show: true,
    width: 152,
    valuesExport: ['status']
  },
  {
    isSortable: true,
    field: 'action',
    title: 'Action',
    show: true,
    width: 152,
    valuesExport: ['action']
  },
  {
    isSortable: true,
    field: 'networkPolicyId',
    title: 'Network Policy Id',
    show: true,
    width: 232,
    valuesExport: ['networkPolicyId']
  },
  {
    isSortable: true,
    field: 'ruleName',
    title: 'Rule Name',
    show: true,
    width: 282,
    valuesExport: ['ruleName']
  },
  {
    isSortable: false,
    field: 'logEnabled',
    title: 'Log Status',
    show: true,
    width: 152,
    valuesExport: ['logEnabled']
  },
  {
    isSortable: true,
    field: 'createdAt',
    title: 'Created At',
    show: true,
    width: 192,
    valuesExport: ['createdAt']
  },
  {
    isSortable: false,
    field: 'updateAt',
    title: 'Updated at',
    show: true,
    width: 192,
    valuesExport: ['updateAt']
  }
];

export const subTableConf = [
  {
    field: 'sources',
    title: 'Source'
  },
  {
    field: 'destination',
    title: 'Destination'
  },
  {
    field: 'service',
    title: 'Service'
  }
];

export const defaultFilters = {
  search: '',
  action: [],
  status: [],
  'sources.endpointType': [],
  'destinations.endpointType': []
};

export const defaultNavigation = {
  fieldName: 'priority',
  direction: initialTableShow.direction * -1,
  currentPage: initialTableShow.currentPage,
  itemsPerPage: initialTableShow.itemsPerPage
};
